import { faStar as faEmptyStar } from "@fortawesome/pro-regular-svg-icons";
import { faStar, faStarHalfAlt } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "../assets/scss/components/_review-stars.scss";
import type { ReviewStarsProps } from "../types/components/ReviewStarsProps";

export const ReviewStars = ({ score, count = 5, starCount = 5 }: ReviewStarsProps) => {
	return (
		<div className="review-stars-section row align-items-start justify-content-start">
			<div className="review-stars">
				{[...Array(starCount)].map((star, index) => {
					var rounded = Math.round((score - index) * 2) / 2;

					var style = faEmptyStar;
					style = rounded >= 0.5 ? faStarHalfAlt : style;
					style = rounded >= 1 ? faStar : style;

					return <FontAwesomeIcon key={index} icon={style} />;
				})}
			</div>

			<div className="reviews-count">({score})</div>
		</div>
	);
};

export default ReviewStars;
